export const API_REQUEST_DELIVERY = `/api/request_delivery`;
export const API_CANCEL_ORDER = `/api/cancel_order`;
export const API_NOTIFICATION = `/api/customer/send_notification`;
export const API_SEND_NOTIFICATION = `/api/send_notification`;
export const API_CLOUD_WATCH = `/api/stream_logs`;
export const API_GET_SHOP_STRIPE_BALANCE = `/api/get_shop_balances`;
export const API_TO_TAKEAWAY = `/api/accept_order`;
export const API_VALIDATE_ORDER = '/api/validate_order_driver';
export const API_PREPARE_ORDER = '/api/prepare_order';
export const API_CREATE_CUSTOM_AND_EXTERNAL_ACCOUNT = '/api/create_custom_and_external_account';
export const API_GET_CUSTOM_VERIFICATION_LINK = '/api/stripe/custom/verification_link';
export const API_CUSTOM_ACCOUNT = '/api/stripe/custom/account';
export const API_UPDATE_CLOSED_SHOP = '/api/shop/closed';
export const API_SEND_ORDER_TO_DRIVERS = '/api/send_order_drivers';
export const API_ORDER_PREPARING_UPDATE = '/api/order/preparing/update';
export const API_UPDATE_DRIVER_ACTIVATION = '/api/drivers/activation';
export const API_GET_CLOSED_DRIVERS = '/api/get_drivers';
export const API_REFUND_PAYMENT = '/api/payement/refund';
export const API_UPDATE_OPTION = '/api/option/update';
export const API_DELETE_OPTION = '/api/option/delete';
export const API_CREATE_PROMOTION = '/api/promotion/update';
export const API_GENERATE_ACCESS_TOKEN_HUBRISE = '/api/hubrise/token';
export const API_UPDATE_SECTION = '/api/section/update';
export const API_UPDATE_PRODUCT = '/api/product/update';
export const API_DELETE_PRODUCT = '/api/product/delete';
export const API_SYNCHRONIZE_MENU_HUBRISE = '/api/hubrise/menu';
export const API_UPLOAD_IMAGE = '/api/image/upload';
export const API_GET_CUSTOMER_ORDERS = '/api/customer/orders';
export const API_DISCONNECT_HUBRISE = '/api/hubrise/disconnect';
export const API_GET_SALES_SHOP = '/api/shop/sales';
export const API_GET_BILLING_SHOP = '/api/shop/billing';
export const API_GET_COMPLETED_ORDERS = '/api/orders/completed';
export const API_SYNCHRONIZE_MENU = '/api/menu/synchronize';
export const GET_PAYOUT_DETAILS = '/api/get_payout_details';
export const API_GET_DRIVER_BILLINGS = '/api/fleet/drivers-billings';
export const API_GET_CUSTOM_STRIPE_API_KEY = (companyId) => `/api/${companyId}/stripe/custom/api-keys`;
